import { WorkBatchSegment, WorkBatchSegmentState } from '../../orders/batches/work-batch'

export class WorkBatchStateUtil {
  public static previousSegmentStarted(
    segments: WorkBatchSegment[],
    currentSegment: WorkBatchSegment | undefined
  ): boolean {
    return this.previousSegmentHasState(segments, currentSegment, [
      WorkBatchSegmentState.PROCESSING,
      WorkBatchSegmentState.COMPLETED,
    ])
  }

  public static previousSegmentFinished(
    segments: WorkBatchSegment[],
    currentSegment: WorkBatchSegment
  ): boolean {
    return this.previousSegmentHasState(segments, currentSegment, [WorkBatchSegmentState.COMPLETED])
  }

  public static previousSegmentHasState(
    segments: WorkBatchSegment[],
    currentSegment: WorkBatchSegment | undefined,
    states: WorkBatchSegmentState[]
  ): boolean {
    const currIndex = currentSegment ? segments.indexOf(currentSegment) : -1
    return currIndex > 0 ? states.includes(segments[currIndex - 1].state) : true
  }

  public static getSegmentByWCId(
    segments: WorkBatchSegment[],
    wcId: string | null
  ): WorkBatchSegment | undefined {
    return segments.find((s) => s.workCenterId === wcId)
  }
}
